var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-check_svg__clip0_973_51385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.708.264A.722.722 0 0110.742.18a.762.762 0 01.083 1.057l-6.233 7.5a.722.722 0 01-1.046.075l-3.3-3a.762.762 0 01-.06-1.06.722.722 0 011.035-.062L3.96 7.18 9.707.264z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-check_svg__clip0_973_51385"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h11v9H0z"
  })))));
}

export default __webpack_public_path__ + "ed81d405707236ae7d54adf7aa3273b3.svg";
export { SvgIconCheck as ReactComponent };